import React from 'react';
import { useIntl } from 'react-intl';
import {
  FilterComponentProps,
  Select,
  useStaticListSource,
} from '@eas/common-web';

export function FilterBooleanCell({
  disabled,
  value,
  onChange,
}: FilterComponentProps) {
  const intl = useIntl();
  const source = useStaticListSource([
    {
      id: 'true',
      name: intl.formatMessage({
        id: 'ES__FILTER_BOOLEAN__YES',
        defaultMessage: 'Ano',
      }),
    },
    {
      id: 'false',
      name: intl.formatMessage({
        id: 'ES__FILTER_BOOLEAN__NO',
        defaultMessage: 'Ne',
      }),
    },
  ]);

  return (
    <Select
      disabled={disabled}
      source={source}
      value={value}
      onChange={onChange}
      valueIsId={true}
    />
  );
}
